











import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters("ui", ["nightMode"]),
  },
})
export default class ToggleTheme extends Vue {
  private nightMode: boolean;
  private imageSource: string | null = null;

  public mounted() {
    this.prepareComponent();
  }

  private prepareComponent() {
    this.setImageSource();
    this.$store.watch(
      (state) => state.ui.nightMode,
      (value) => this.setImageSource(),
    );
  }

  private setImageSource() {
    this.imageSource = `theme/${this.nightMode ? "sun" : "moon"}`;
  }

  private changeImageSource() {
    this.imageSource = `theme/hover/${this.nightMode ? "sun" : "moon"}-hover`;
  }
}
